"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CampaignHolder = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./campaigns.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CampaignHolder = _ref => {
  let {
    campaignImageUrl,
    campaignBaseUrl,
    campaignImageDescription,
    customCssClass = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "campaignHolder ".concat(customCssClass)
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: "100%",
    height: "100%",
    className: "campaignImage",
    alt: campaignImageDescription,
    src: typeof campaignImageUrl === 'function' ? campaignImageUrl(campaignBaseUrl) : campaignImageUrl
  }));
};
exports.CampaignHolder = CampaignHolder;
CampaignHolder.propTypes = {
  campaignImageUrl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  campaignBaseUrl: _propTypes.default.string,
  campaignImageDescription: _propTypes.default.string,
  customCssClass: _propTypes.default.string
};
var _default = exports.default = CampaignHolder;